
import Foot from "@/layouts/foot";
import Campaigndetailplaceholder from "@/components/placeholders/campaigndetailplaceholder";
export default {
  name: "index2",
  components: {Campaigndetailplaceholder, Foot},
  data() {
    return {
      brands: [],
      brandNames: ''
    }
  },
  mounted() {
    this.getBrandName()
  },
  methods:{
    getBrandName(){
      let brandNames = ''
      for (let key in this.brands) {
        this.brandNames += this.brands[key].name + ','
      }
    }
  },
  head() {
    return {
      title: 'Μάρκες ελαστικών',
      meta: [
        { hid: 'description', name: 'description', content: 'Lastik satın alma deneyiminizi güvenilir markalar aracılığıyla güçlendirin. Tirelet güvencesiyle kolayca satın alın.' },
        { hid: 'keywords', name: 'keywords', content:"tirelet"+","+ this.brandNames}
      ],
    }
  },
  computed: {
    city: {
      get() {
        return this.$store.state.city.slug
      },
      set(value) {
        this.$cookies.set('city', value, {
          sameSite: 'lax'
        })
        this.$store.commit('city/setCitySlug', value)
      }
    },
  },
  async fetch() {
    var brands = await this.$http.$get(`/tire/listing/brands`)
    if (brands.status) {
      this.brands = brands.data.brands
    }
  }
}
